const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımda',
      experience: 'Deneyimler',
      projects: 'Projeler',
      blog: 'Blog',
      certificates: 'Sertifikalar',
      contact: 'İletişim',
      contactBtn: 'İletişime Geç',
      menuToggle: 'Menüyü aç/kapat',
    },
    experience: {
      badge: 'Deneyimler',
      heading: 'Nerelerde çalıştım, neler öğrendim',
      subheading: 'Staj, serbest çalışma, kendi ürünlerim, eğitim ve topluluk çalışmalarım; en yeniden en eskiye.',
      seoTitle: 'Deneyimler',
      seoDesc: 'Erkan Turgut\'un iş, staj, eğitim ve topluluk deneyimleri: Microsoft Summer School yapay zekâ stajı, ŞantiyeOS, serbest yazılım geliştirme ve daha fazlası.',
      current: 'devam ediyor',
      downloadCV: 'CV\'yi indir',
      entries: 'kayıt',
    },
    hero: {
      badge: 'Yeni Fırsatlara Açık',
      ctaProjects: 'Projelerimi Gör',
      ctaContact: 'İletişime Geç',
      scroll: 'Scroll',
      description:
        'Modern web teknolojileri, Python, Java ve yapay zeka alanlarında kullanıcı odaklı uygulamalar geliştiriyorum. Her projede kaliteli kod ve mükemmel deneyim önceliğim.',
      badgeRole: 'Full Stack',
      badgeRoleSub: 'Developer',
      badgeAI: 'AI',
      badgeAISub: 'Enthusiast',
    },
    about: {
      badge: 'Hakkımda',
      heading: 'Merhaba, ben Erkan',
      subheading:
        'Yazılım geliştirme tutkum ve sürekli öğrenme isteğimle Full Stack, Python, Java ve AI alanlarında kendimi geliştirmeye devam ediyorum.',
      downloadCV: "CV'yi İndir",
      storyTitle: 'Hikayem',
      story1:
        'Yazılım serüvenim üniversite yıllarımda başladı. O günden bu yana Python, Java, React ve AI alanlarında yoğunlaşarak birçok proje hayata geçirdim.',
      story2:
        'Django ve Flask ile backend, React ile modern frontend geliştirme deneyimim bulunuyor. Unity ve C# ile oyun geliştirme projeleri de ürettim. PHP ile çeşitli web uygulamaları geliştirdim.',
      story3:
        'Yazılımı gerçekten severek yapıyorum — her projede hem teknik kaliteyi hem de kullanıcı deneyimini ön planda tutuyorum.',
      shortTerm: 'Kısa Vadeli',
      longTerm: 'Uzun Vadeli',
      shortTermGoals: ['Yeni teknolojiler öğrenmek', 'Açık kaynak katkısı', 'Daha fazla proje'],
      longTermGoals: ['Yazılım şirketi kurmak', 'Mentorluk yapmak', 'Topluluğa katkı sağlamak'],
      techStack: 'Teknoloji Yığını',
      seoTitle: 'Hakkımda',
      seoDesc:
        'Erkan Turgut kimdir? Yazılım geliştirme tutkusu, yetenekleri ve kariyer hedefleri hakkında bilgiler.',
    },
    projects: {
      badge: 'Portfolyo',
      heading: 'Projelerim',
      subheading: 'Geliştirdiğim projeler ve kullandığım teknolojiler.',
      loading: 'Projeler yükleniyor...',
      totalProjects: 'Toplam Proje',
      technologies: 'Teknoloji',
      featured: 'Öne Çıkan',
      featuredBadge: 'Öne Çıkan Proje',
      all: 'Tümü',
      noResults: 'Bu teknoloji ile proje bulunamadı',
      noResultsHint: 'Farklı bir filtre seçin.',
      seoTitle: 'Projelerim',
      seoDesc:
        'Erkan Turgut tarafından geliştirilen web uygulamaları, AI projeleri ve yazılım çözümleri.',
      about: 'Proje Hakkında',
      usedTech: 'Kullanılan Teknolojiler',
      liveDemo: 'Canlı Demo',
      goBack: 'Geri Dön',
      projectsLabel: 'Projeler',
      viewImage: 'Görseli büyüt',
      closePreview: 'Önizlemeyi kapat',
    },
    blog: {
      badge: 'Yazılarım & Paylaşımlarım',
      heading: 'Blog',
      subheading:
        'Yazılım, teknoloji ve kişisel deneyimlerim hakkında düşüncelerimi paylaştığım köşem.',
      visitMedium: 'Medium Profilimi Ziyaret Et',
      all: 'Tümü',
      internal: 'Site İçi',
      external: 'Medium',
      kaggle: 'Kaggle',
      searchPlaceholder: 'Blog yazılarında ara...',
      loading: 'Blog yazıları yükleniyor...',
      errorLoading: 'Bloglar yüklenirken bir hata oluştu.',
      noResults: 'Sonuç bulunamadı',
      noBlogs: 'Henüz blog yazısı yok',
      noMatchPrefix: '',
      noMatchSuffix: 'için eşleşme bulunamadı.',
      comingSoon: 'Yakında yeni yazılar eklenecek.',
      clearSearch: 'Aramayı Temizle',
      totalPosts: 'Toplam Yazı',
      totalTags: 'Toplam Etiket',
      read: 'Oku',
      minRead: 'dk',
      seoTitle: 'Blog',
      seoDesc: 'Yazılım geliştirme, teknoloji trendleri ve kişisel deneyimlerim hakkında paylaşımlar.',
      notFound: 'Blog yazısı bulunamadı',
      notFoundSub: 'Aradığınız blog yazısı mevcut değil veya kaldırılmış olabilir.',
      backToBlog: "Blog'a Dön",
      author: 'Yazar',
      publishDate: 'Yayın Tarihi',
      readingTime: 'Okuma Süresi',
      minute: 'dakika',
      share: 'Bu yazıyı paylaş',
      shareSub: 'Beğendiysen arkadaşlarınla paylaşabilirsin',
      copyLink: 'Linki kopyala',
      authorBio:
        'Full Stack Developer olarak modern web teknolojileri ile kullanıcı dostu ve performanslı uygulamalar geliştiriyorum.',
      discoverPosts: 'Diğer Yazıları Keşfet',
      detailLoading: 'Blog yazısı yükleniyor...',
    },
    certificates: {
      badge: 'Başarılarım',
      heading: 'Sertifikalarım',
      subheading: 'Sürekli öğrenme yolculuğumda kazandığım sertifikalar.',
      loading: 'Sertifikalar yükleniyor...',
      total: 'Toplam',
      issuers: 'Kurum',
      lastYear: 'Son 1 Yıl',
      learning: 'Öğrenme',
      empty: 'Geliştirme aşamasında',
      emptySub: 'Yakında yeni sertifikalar eklenecek.',
      seoTitle: 'Sertifikalarım',
      seoDesc:
        "Erkan Turgut'un kazandığı yazılım ve teknoloji sertifikaları, eğitimleri ve başarıları.",
    },
    contact: {
      badge: 'Bana Ulaşın',
      heading: 'İletişim',
      subheading: 'İşbirliği teklifleri veya sadece merhaba demek için mesaj gönderin.',
      contactInfo: 'İletişim Bilgileri',
      location: 'Konum',
      locationValue: 'İstanbul, Türkiye',
      available: 'Müsait — Yeni projelere açık',
      availableSub: 'Freelance projeler ve tam zamanlı pozisyonlar için iletişime geçebilirsiniz.',
      seoTitle: 'İletişim',
      seoDesc:
        'Projeleriniz için işbirliği yapmak veya benimle iletişime geçmek için bu sayfayı kullanabilirsiniz.',
    },
    form: {
      title: 'Mesaj Gönder',
      name: 'Ad Soyad',
      namePlaceholder: 'Adınız Soyadınız',
      email: 'E-posta',
      emailPlaceholder: 'ornek@email.com',
      subject: 'Konu',
      subjectPlaceholder: 'Mesajınızın konusu',
      message: 'Mesaj',
      messagePlaceholder: 'Mesajınızı buraya yazın...',
      submit: 'Mesaj Gönder',
      sending: 'Gönderiliyor...',
      successMsg: 'Mesajınız gönderildi! En kısa sürede dönüş yapacağım.',
      errorMsg: 'Mesaj gönderilemedi. Lütfen tekrar deneyin.',
      secure: 'Mesajınız güvenli bir şekilde iletilecektir.',
      privacyNote: 'Gönderdiğin bilgiler yalnızca sana yanıt vermek için kullanılır.',
      privacyLink: 'Gizlilik',
    },
    footer: {
      description:
        'Modern web teknolojileri, Python, Java ve AI alanlarında kullanıcı odaklı çözümler geliştiriyorum.',
      pages: 'Sayfalar',
      contact: 'İletişim',
      locationValue: 'İstanbul, Türkiye',
      openToWork: 'Projeye Açık',
      rights: 'Tüm hakları saklıdır.',
      sitemap: 'Site haritası',
      privacy: 'Gizlilik',
    },
    home: {
      seoTitle: 'Yazılım Geliştirici & Full Stack Developer',
      seoDesc:
        "Erkan Turgut'un kişisel portfolyo sitesi. Modern web teknolojileri, Python, Java ve AI projeleri geliştiren Full Stack Developer.",
      featuredTitle: 'Öne çıkan projeler',
      featuredSub: 'Canlıda çalışan ürünler ve yapay zekâ çalışmaları.',
      allProjects: 'Tüm projeler',
      latestTitle: 'Son yazılar',
      latestSub: 'Geliştirirken öğrendiklerimi yazıyorum.',
      allPosts: 'Tüm yazılar',
      experienceTitle: 'Son deneyimler',
      allExperience: 'Tüm deneyimler',
      minRead: 'dk okuma',
    },
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About',
      experience: 'Experience',
      projects: 'Projects',
      blog: 'Blog',
      certificates: 'Certificates',
      contact: 'Contact',
      contactBtn: 'Get In Touch',
      menuToggle: 'Toggle menu',
    },
    experience: {
      badge: 'Experience',
      heading: 'Where I\'ve worked and what I\'ve learned',
      subheading: 'Internships, freelance work, my own products, education and community work — newest first.',
      seoTitle: 'Experience',
      seoDesc: 'Erkan Turgut\'s work, internship, education and community experience: Microsoft Summer School AI internship, ŞantiyeOS, freelance software development and more.',
      current: 'ongoing',
      downloadCV: 'Download CV',
      entries: 'entries',
    },
    hero: {
      badge: 'Open to New Opportunities',
      ctaProjects: 'See My Projects',
      ctaContact: 'Contact Me',
      scroll: 'Scroll',
      description:
        'I build user-focused applications with modern web technologies, Python, Java, and AI. Quality code and excellent experience are my top priorities in every project.',
      badgeRole: 'Full Stack',
      badgeRoleSub: 'Developer',
      badgeAI: 'AI',
      badgeAISub: 'Enthusiast',
    },
    about: {
      badge: 'About Me',
      heading: "Hi, I'm Erkan",
      subheading:
        'With a passion for software development and a drive to keep learning, I continue to grow in Full Stack, Python, Java, and AI.',
      downloadCV: 'Download CV',
      storyTitle: 'My Story',
      story1:
        'My software journey started during my university years. Since then, I have focused on Python, Java, React, and AI, bringing many projects to life.',
      story2:
        'I have backend experience with Django and Flask, and modern frontend experience with React. I have also built game development projects with Unity and C#, and various web applications with PHP.',
      story3:
        'I genuinely love what I do — in every project, I keep both technical quality and user experience at the forefront.',
      shortTerm: 'Short Term',
      longTerm: 'Long Term',
      shortTermGoals: ['Learn new technologies', 'Open source contributions', 'More projects'],
      longTermGoals: ['Found a software company', 'Mentoring others', 'Contribute to the community'],
      techStack: 'Tech Stack',
      seoTitle: 'About Me',
      seoDesc:
        'Who is Erkan Turgut? Information about his passion for software development, skills, and career goals.',
    },
    projects: {
      badge: 'Portfolio',
      heading: 'My Projects',
      subheading: 'Projects I built and technologies I used.',
      loading: 'Loading projects...',
      totalProjects: 'Total Projects',
      technologies: 'Technologies',
      featured: 'Featured',
      featuredBadge: 'Featured Project',
      all: 'All',
      noResults: 'No projects found for this technology',
      noResultsHint: 'Select a different filter.',
      seoTitle: 'My Projects',
      seoDesc:
        'Web applications, AI projects, and software solutions developed by Erkan Turgut.',
      about: 'About the Project',
      usedTech: 'Technologies Used',
      liveDemo: 'Live Demo',
      goBack: 'Go Back',
      projectsLabel: 'Projects',
      viewImage: 'View image',
      closePreview: 'Close preview',
    },
    blog: {
      badge: 'My Articles & Posts',
      heading: 'Blog',
      subheading:
        'The corner where I share my thoughts on software, technology, and personal experiences.',
      visitMedium: 'Visit My Medium Profile',
      all: 'All',
      internal: 'On-Site',
      external: 'Medium',
      kaggle: 'Kaggle',
      searchPlaceholder: 'Search blog posts...',
      loading: 'Loading blog posts...',
      errorLoading: 'An error occurred while loading blogs.',
      noResults: 'No results found',
      noBlogs: 'No blog posts yet',
      noMatchPrefix: 'No matches found for',
      noMatchSuffix: '.',
      comingSoon: 'New posts coming soon.',
      clearSearch: 'Clear Search',
      totalPosts: 'Total Posts',
      totalTags: 'Total Tags',
      read: 'Read',
      minRead: 'min',
      seoTitle: 'Blog',
      seoDesc:
        'Posts about software development, technology trends, and personal experiences.',
      notFound: 'Blog post not found',
      notFoundSub:
        'The blog post you are looking for does not exist or has been removed.',
      backToBlog: 'Back to Blog',
      author: 'Author',
      publishDate: 'Published',
      readingTime: 'Reading Time',
      minute: 'min read',
      share: 'Share this post',
      shareSub: 'Share it with your friends if you enjoyed it',
      copyLink: 'Copy link',
      authorBio:
        'As a Full Stack Developer, I build user-friendly and performant applications with modern web technologies.',
      discoverPosts: 'Discover More Posts',
      detailLoading: 'Loading blog post...',
    },
    certificates: {
      badge: 'My Achievements',
      heading: 'My Certificates',
      subheading: 'Certificates earned along my continuous learning journey.',
      loading: 'Loading certificates...',
      total: 'Total',
      issuers: 'Issuers',
      lastYear: 'Last Year',
      learning: 'Learning',
      empty: 'Under development',
      emptySub: 'New certificates coming soon.',
      seoTitle: 'My Certificates',
      seoDesc:
        "Erkan Turgut's software and technology certificates, trainings, and achievements.",
    },
    contact: {
      badge: 'Get In Touch',
      heading: 'Contact',
      subheading:
        'Send a message for collaboration proposals or just to say hello.',
      contactInfo: 'Contact Info',
      location: 'Location',
      locationValue: 'Istanbul, Turkey',
      available: 'Available — Open to new projects',
      availableSub:
        'Feel free to reach out for freelance projects and full-time positions.',
      seoTitle: 'Contact',
      seoDesc:
        'Use this page to collaborate on projects or get in touch with me.',
    },
    form: {
      title: 'Send a Message',
      name: 'Full Name',
      namePlaceholder: 'Your Full Name',
      email: 'Email',
      emailPlaceholder: 'example@email.com',
      subject: 'Subject',
      subjectPlaceholder: 'Subject of your message',
      message: 'Message',
      messagePlaceholder: 'Write your message here...',
      submit: 'Send Message',
      sending: 'Sending...',
      successMsg: 'Message sent! I will get back to you as soon as possible.',
      errorMsg: 'Failed to send message. Please try again.',
      secure: 'Your message will be delivered securely.',
      privacyNote: 'Your details are only used to reply to you.',
      privacyLink: 'Privacy',
    },
    footer: {
      description:
        'I build user-focused solutions with modern web technologies, Python, Java, and AI.',
      pages: 'Pages',
      contact: 'Contact',
      locationValue: 'Istanbul, Turkey',
      openToWork: 'Open to Work',
      rights: 'All rights reserved.',
      sitemap: 'Sitemap',
      privacy: 'Privacy',
    },
    home: {
      seoTitle: 'Software Developer & Full Stack Developer',
      seoDesc:
        "Erkan Turgut's personal portfolio site. Full Stack Developer building modern web technologies, Python, Java, and AI projects.",
      featuredTitle: 'Featured projects',
      featuredSub: 'Products running in production and AI work.',
      allProjects: 'All projects',
      latestTitle: 'Latest writing',
      latestSub: 'Notes on what I learn while building.',
      allPosts: 'All posts',
      experienceTitle: 'Recent experience',
      allExperience: 'All experience',
      minRead: 'min read',
    },
  },
};

export default translations;
